<template>
 <div class="audio active">
  <svg>
    <path d="M2,2 L10,20 L18,10"></path>
  </svg>
 </div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'music',
  mounted() {
    let xs = []
    for (var i = 0; i <= 500; i++) {
      xs.push(i)
    }

    let t = 0

    var tight = 5
    var height = 14
    var width = 7

    var myAudio = document.getElementById('audio');

    function animate() {
    
    let points = xs.map(x => {
      
      let y = height + width * Math.sin((x + t) / tight)
      
      return [x, y]
    })
    
    let path = "M" + points.map(p => {
      return p[0] + "," + p[1]
    }).join(" L")
    
      document.querySelector("path").setAttribute("d", path)
    
    t += 0.5
      if (myAudio.paused) 
      {
        if(width > 0)
        {
          width -= 0.2
        }
      } else {
        if(width < 7)
        {
          width += 0.2
        }
      }
    
    requestAnimationFrame(animate)
  }

  animate()
    $('.audio').click(function(){
      if (myAudio.paused) 
      {
        myAudio.play();
        myAudio.volume = 0.05;
      } else {
        myAudio.pause();
      }
    })    
  }
}
</script>

<style scoped>

svg {
  width: 28px;
  height: 30px;
  transform: translate(0,0);
  border-radius: 50%;
}

path {
  stroke: #FFF;
  stroke-width: 1px;
  stroke-linecap: round;
  fill: none;
}

.audio
{
  height: 30px;
  width: 30px;
  position: fixed;
  bottom: 30px;
  left: 30px;
  border: 1px solid white;
  background-size: 105%;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 50%; 
  cursor: pointer;
  transition: 0.3s;
}

@media only screen and (max-width: 900px) {

}
</style>
